import { useState } from "react";
import { APP_URL } from "../lib/config";

/**
 * Display + acciones del QR de un tenant. Reusable en /admin y /platform.
 * El QR apunta a /?join=<slug> y se genera on-the-fly vía api.qrserver.com.
 */
export function TenantQR({ tenantId, tenantName, size = 320 }: {
  tenantId: string;
  tenantName?: string;
  size?: number;
}) {
  const [copied, setCopied] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const joinUrl = `${APP_URL}/?join=${encodeURIComponent(tenantId)}`;
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=20&data=${encodeURIComponent(joinUrl)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(joinUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* ignore */
    }
  };

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `${tenantName ?? "Mi comercio"} en Fideliza`,
          text: "Suma puntos y canjea rewards en cada compra.",
          url: joinUrl
        });
      } catch {
        /* user cancelled */
      }
    } else {
      copy();
    }
  };

  const download = async () => {
    setDownloading(true);
    try {
      const res = await fetch(qrUrl);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `fideliza-${tenantId}-qr.png`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      window.open(qrUrl, "_blank");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="flex flex-col items-center gap-3">
      <div className="rounded-2xl bg-white p-4 ring-1 ring-leaf-100">
        <img src={qrUrl} alt="QR del comercio" className="block" style={{ width: size, height: size }} />
      </div>
      <p className="text-center text-xs text-leaf-700">
        Tus clientes lo escanean y entran a la app sumando tickets, sin instalar nada.
      </p>
      <code className="block max-w-full overflow-hidden text-ellipsis whitespace-nowrap rounded-lg bg-leaf-50 px-3 py-2 text-center text-xs text-leaf-800">
        {joinUrl}
      </code>
      <div className="flex w-full flex-col gap-2">
        <button onClick={download} disabled={downloading} className="btn-primary">
          {downloading ? "Descargando..." : "Descargar QR (PNG)"}
        </button>
        <button onClick={share} className="btn-secondary">
          Compartir link
        </button>
        <button onClick={copy} className="btn-ghost text-sm">
          {copied ? "✓ Link copiado" : "Copiar link"}
        </button>
      </div>
    </div>
  );
}
